module.exports = [
    {
        item:  "Отключенные камеры",
        icon:  "videocam_off",
        route: "/disabled_cameras",
        name:  "disabled_cameras"
    },
    {
        item:  "Не привязанные камеры",
        icon:  "videocam",
        route: "/not_provisioned_cameras",
        name:  "not_provisioned_cameras"
    },
    {
        item:  "Пользователи",
        icon:  "face",
        route: "/users",
        name:  "users"
    },
    {
        item:  "Администраторы",
        icon:  "group",
        route: "/admins",
        name:  "admins"
    }
];
